import { useEffect } from "react";

export const SITE_URL = "https://digihubsolution.com";

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#organization`,
  name: "Digi Hub Solution",
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  image: `${SITE_URL}/logo512.png`,
  telephone: "+91-98087-24448",
  email: "hubdigisolution@gmail.com",
  foundingDate: "2018",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Devender Vihar, Gumaniwala",
    addressLocality: "Rishikesh",
    addressRegion: "Uttarakhand",
    addressCountry: "IN",
  },
  areaServed: "IN",
};

const setMeta = (attr, key, value) => {
  if (!value) return;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
};

export default function Seo({ title, description, image, url, jsonLd }) {
  useEffect(() => {
    if (title) document.title = `${title} · Digi Hub Solution`;
    const canonical = url || `${SITE_URL}${window.location.pathname}`;

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, image, url]);

  const ldJson = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!ldJson) return undefined;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-jsonld", "true");
    script.textContent = ldJson;
    document.head.appendChild(script);
    return () => script.remove();
  }, [ldJson]);

  return null;
}
